import CircleIcon from '@mui/icons-material/Circle';
import { ListItemIcon, ListItemText } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import useAnchorMenu from '../../../hooks/useAnchorMenu';
import './SortByDropdown.scss';

interface SortByDropdownProps {
  sortOption: string;
  setSortOption: React.Dispatch<React.SetStateAction<string>>;
}

function SortByDropdown({ sortOption, setSortOption }: SortByDropdownProps) {
  const menu = useAnchorMenu<HTMLButtonElement>();

  const handleMenuItemClick = (option: string) => {
    // Persistence belongs to whoever owns the state: TripsList keeps this in
    // usePersistedState, so writing sessionStorage here as well would be a
    // second source of truth for the same key.
    setSortOption(option);
    // Selecting an option used to leave the menu open: MUI MenuItem does not
    // close on click, and the former onClose guard also swallowed a second
    // click on the trigger, so the menu could only be dismissed by Escape.
    menu.close();
  };

  return (
    <>
      <Button
        className='sort-by-button'
        aria-controls='simple-menu'
        aria-haspopup='true'
        onClick={menu.open}
      >
        {sortOption}
      </Button>
      <Menu
        className='sort-by-styled-menu'
        id='simple-menu'
        anchorEl={menu.anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        keepMounted
        open={menu.isOpen}
        onClose={menu.close}
      >
        {['Alphabetical: A-Z', 'Last Opened'].map((option) => (
          <MenuItem
            className='sort-by-styled-menu-item'
            key={option}
            onClick={() => handleMenuItemClick(option)}
            selected={option === sortOption}
          >
            {option === sortOption && (
              <ListItemIcon>
                <CircleIcon
                  fontSize='small'
                  style={{ color: '#FFD700' }}
                />
              </ListItemIcon>
            )}
            <ListItemText
              className='sort-by-styled-menu-item-text'
              primary={option}
              primaryTypographyProps={{
                style: { fontWeight: option === sortOption ? 'bold' : 'normal' },
              }}
              style={{ marginLeft: option === sortOption ? 0 : 36 }} // provides space for active sort icon
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

SortByDropdown.displayName = 'SortByDropdown';
export default SortByDropdown;
